module.exports = __webpack_public_path__ + "img/contact-back.4d927ec8.jpg";